import { render, staticRenderFns } from "./PostionIntro.vue?vue&type=template&id=63b122e6&scoped=true"
import script from "./PostionIntro.vue?vue&type=script&lang=js"
export * from "./PostionIntro.vue?vue&type=script&lang=js"
import style0 from "./PostionIntro.vue?vue&type=style&index=0&id=63b122e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b122e6",
  null
  
)

export default component.exports